import { Popover, Toggle, Tooltip } from '@ets/design-system';
import { useState, CSSProperties } from 'react';

import { useIEnvision, useSelector } from '_common/hooks';
import NotificationsPopover from '../Popovers/NotificationsPopover/NotificationsPopover';
import { useIntl } from 'react-intl';
import NotificationsCenterContext from './NotificationsCenterContext';

type NotificationsCenterProps = {
  margin?: CSSProperties['margin'];
  object: doDOC.SuiteObject;
  navigateToObject: ({
    objectType,
    objectId,
    documentId,
  }: {
    objectType: 'comment' | 'suggestion' | 'task' | 'node' | 'annotation';
    objectId: ObjectId;
    documentId: ObjectId;
  }) => void;
};

const NotificationsCenter = ({ margin, object, navigateToObject }: NotificationsCenterProps) => {
  const intl = useIntl();
  const unreadNotifications = useSelector((state) => state.notifications.unreadCount);
  const isIEnvision = useIEnvision();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <NotificationsCenterContext.Provider value={{ navigateToObject: navigateToObject }}>
      <Popover.Root
        open={isOpen}
        onOpenChange={() => {
          if (!isIEnvision) setIsOpen(!isOpen);
        }}
        placement="bottom-end"
        options={{
          offset: 8,
          size: {
            padding: 40,
          },
        }}
      >
        <Popover.Trigger>
          <Tooltip
            content={intl.formatMessage({ id: 'NO_PERMISSION_TO_PERFORM_ACTION' })}
            placement="left"
            visible={isIEnvision}
            testId="notifications-no-permission"
          >
            <Toggle
              variant="link"
              size="m"
              iconProps={{
                icon: 'bell',
                color: 'primary',
                badge:
                  unreadNotifications > 0
                    ? {
                        number: unreadNotifications,
                        position: 'top-right',
                        size: 'm',
                      }
                    : undefined,
              }}
              style={{ margin: margin ?? '0 1rem 0 0' }}
              isToggled={isOpen}
              onClick={() => {
                if (!isIEnvision) setIsOpen(!isOpen);
              }}
              disabled={isIEnvision}
              testId="notifications"
            />
          </Tooltip>
        </Popover.Trigger>
        <Popover.Content testId="notifications-center" style={{ marginBottom: '5rem' }}>
          <NotificationsPopover
            closePopover={() => setIsOpen(false)}
            popperHeight={640}
            object={object}
          />
        </Popover.Content>
      </Popover.Root>
    </NotificationsCenterContext.Provider>
  );
};

export default NotificationsCenter;
